import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common';

@Component({
  selector: 'app-supplier-round-list-ssy1230detail-details',
  templateUrl: 'supplier-round-list-ssy1230detail-details.component.html'
})
export class SupplierRoundListSsy1230detailDetailsComponent implements OnInit {

    viewState = ViewState;
  
	constructor() { }

	ngOnInit (): void {
		//Auth.checkAuthorization('');
	}
	
	// custom-start

	
	
  
	// custom-end

	

}
